import { defineNuxtPlugin } from '#app/nuxt'
import { LazyLoginPopNoticeModal, LazyNoticeBoardModal, LazyQnaBoardModal, LazySaiIframe, LazyTheHeader, LazyTheSidebar, LazySaiChat, LazyCalendar, LazyCompetencyGroupTable, LazyEditUiTable, LazyEmpty, LazyGlobalConfirmDialog, LazyImagePreviewModalHost, LazyQuillEditor, LazyQuillViewer, LazyScrollTopButton, LazySearchSelector, LazySearchTreeItem, LazyStepNavigation, LazyTinyEditor, LazyTinymceEditor, LazyTinymceViewer, LazyUiAccordion, LazyUiAccordionMenu, LazyUiAlert, LazyUiAttachment, LazyUiButton, LazyUiCheckbox, LazyUiConfirm, LazyUiDatePicker, LazyUiFilterModal, LazyUiFormItem, LazyUiFormLayout, LazyUiInput, LazyUiInputMultiple, LazyUiLoadingSpinner, LazyUiModal, LazyUiMultiSelect, LazyUiPaging, LazyUiRadio, LazyUiRating, LazyUiSearchableSelect, LazyUiSegment, LazyUiSelect, LazyUiSwitch, LazyUiTable, LazyUiTableDefault, LazyUiTabs, LazyUiTag, LazyUiTextarea, LazyUiToast, LazyUiToastNotification, LazyUiTooltip, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["LoginPopNoticeModal", LazyLoginPopNoticeModal],
["NoticeBoardModal", LazyNoticeBoardModal],
["QnaBoardModal", LazyQnaBoardModal],
["SaiIframe", LazySaiIframe],
["TheHeader", LazyTheHeader],
["TheSidebar", LazyTheSidebar],
["SaiChat", LazySaiChat],
["Calendar", LazyCalendar],
["CompetencyGroupTable", LazyCompetencyGroupTable],
["EditUiTable", LazyEditUiTable],
["Empty", LazyEmpty],
["GlobalConfirmDialog", LazyGlobalConfirmDialog],
["ImagePreviewModalHost", LazyImagePreviewModalHost],
["QuillEditor", LazyQuillEditor],
["QuillViewer", LazyQuillViewer],
["ScrollTopButton", LazyScrollTopButton],
["SearchSelector", LazySearchSelector],
["SearchTreeItem", LazySearchTreeItem],
["StepNavigation", LazyStepNavigation],
["TinyEditor", LazyTinyEditor],
["TinymceEditor", LazyTinymceEditor],
["TinymceViewer", LazyTinymceViewer],
["UiAccordion", LazyUiAccordion],
["UiAccordionMenu", LazyUiAccordionMenu],
["UiAlert", LazyUiAlert],
["UiAttachment", LazyUiAttachment],
["UiButton", LazyUiButton],
["UiCheckbox", LazyUiCheckbox],
["UiConfirm", LazyUiConfirm],
["UiDatePicker", LazyUiDatePicker],
["UiFilterModal", LazyUiFilterModal],
["UiFormItem", LazyUiFormItem],
["UiFormLayout", LazyUiFormLayout],
["UiInput", LazyUiInput],
["UiInputMultiple", LazyUiInputMultiple],
["UiLoadingSpinner", LazyUiLoadingSpinner],
["UiModal", LazyUiModal],
["UiMultiSelect", LazyUiMultiSelect],
["UiPaging", LazyUiPaging],
["UiRadio", LazyUiRadio],
["UiRating", LazyUiRating],
["UiSearchableSelect", LazyUiSearchableSelect],
["UiSegment", LazyUiSegment],
["UiSelect", LazyUiSelect],
["UiSwitch", LazyUiSwitch],
["UiTable", LazyUiTable],
["UiTableDefault", LazyUiTableDefault],
["UiTabs", LazyUiTabs],
["UiTag", LazyUiTag],
["UiTextarea", LazyUiTextarea],
["UiToast", LazyUiToast],
["UiToastNotification", LazyUiToastNotification],
["UiTooltip", LazyUiTooltip],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
